import { __awaiter } from "tslib";
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ReducerType } from './types';
import { fetchCustomer, setCustomerAuth } from './customer';
const initialState = {
    otpSent: false,
    loading: 'idle',
    error: null
};
export var OneTimePasscodeActionType;
(function (OneTimePasscodeActionType) {
    OneTimePasscodeActionType["OneTimePasscodeCustomer"] = "oneTimePasscode/oneTimePasscodeCustomer";
    OneTimePasscodeActionType["SignInCustomer"] = "oneTimePasscode/signInCustomer";
})(OneTimePasscodeActionType || (OneTimePasscodeActionType = {}));
export const sendOneTimePasscode = createAsyncThunk(OneTimePasscodeActionType.OneTimePasscodeCustomer, ({ data, callback }, { dispatch, getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const api = getState().config.api;
        const response = yield api.postCustomerSignIn(data);
        if (data.one_time_passcode) {
            dispatch(setCustomerAuth(response));
            yield dispatch(fetchCustomer());
            if (callback)
                callback();
            return false;
        }
        else {
            return true;
        }
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const signInCustomer = createAsyncThunk(OneTimePasscodeActionType.SignInCustomer, ({ data, callback }, { dispatch, getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const api = getState().config.api;
        const response = yield api.postCustomerSignIn(data);
        dispatch(setCustomerAuth(response));
        yield dispatch(fetchCustomer());
        if (callback)
            callback();
        return;
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
const oneTimePasscodeSlice = createSlice({
    name: ReducerType.OneTimePasscode,
    initialState,
    reducers: {
        resetOneTimePasscode: () => initialState,
        toggleOtpSent: (state, action) => {
            state.otpSent = action.payload;
        }
    },
    extraReducers: builder => {
        builder
            .addCase(sendOneTimePasscode.fulfilled, (state, action) => {
            state.otpSent = action.payload;
            state.loading = 'idle';
            state.error = null;
        })
            .addCase(sendOneTimePasscode.pending, state => {
            state.loading = 'pending';
        })
            .addCase(sendOneTimePasscode.rejected, (state, action) => {
            state.loading = 'idle';
            state.error = action.payload;
        })
            .addCase(signInCustomer.fulfilled, state => {
            state.loading = 'idle';
            state.error = null;
        })
            .addCase(signInCustomer.pending, state => {
            state.loading = 'pending';
        })
            .addCase(signInCustomer.rejected, (state, action) => {
            state.loading = 'idle';
            state.error = action.payload;
        });
    }
});
export const { resetOneTimePasscode, toggleOtpSent } = oneTimePasscodeSlice.actions;
export const selectOneTimePasscode = (state) => state.oneTimePasscode;
export const oneTimePasscodeReducer = oneTimePasscodeSlice.reducer;
